import { render, staticRenderFns } from "./ComprometimentoDesaprovar.vue?vue&type=template&id=06f75c09"
import script from "./ComprometimentoDesaprovar.vue?vue&type=script&lang=js"
export * from "./ComprometimentoDesaprovar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports